export default "__VITE_ASSET__72bc7ee5__"